// test1106
(1106 && 0);
